// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"J9-z"};